import { Link } from 'react-router-dom';
import { images } from '../../assets/images';
import { ArrowRight } from 'lucide-react';

const categories = [
  {
    id: 1,
    title: 'Industrial Capacitors',
    image: images.categories.capacitors,
    link: '/products'
  },
  {
    id: 2,
    title: 'Fan Regulators',
    image: images.categories.regulators,
    link: '/products'
  },
  {
    id: 3,
    title: 'Oil-Filled Capacitors',
    image: images.categories.oilCapacitors,
    link: '/products'
  },
  {
    id: 4,
    title: 'Electronic Components',
    image: images.categories.components,
    link: '/products'
  }
];

const ProductsOverview = () => {
  return (
    <section className="py-20 bg-slate-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="text-orange-600 font-bold uppercase tracking-wider text-sm">Our Products</span>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mt-2">High-Performance Solutions</h2>
          <p className="text-slate-600 mt-4 max-w-2xl mx-auto">
            Explore our wide range of electrical products designed for durability and efficiency.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {categories.map((cat) => (
            <Link 
              key={cat.id} 
              to={cat.link}
              className="group bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
            >
              <div className="h-48 overflow-hidden relative">
                <img 
                  src={cat.image} 
                  alt={cat.title} 
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-slate-900/0 group-hover:bg-slate-900/20 transition-colors duration-300"></div>
              </div>
              <div className="p-6 text-center">
                <h3 className="text-lg font-bold text-slate-900 mb-2 group-hover:text-orange-600 transition-colors">
                  {cat.title}
                </h3>
                <span className="inline-flex items-center text-sm text-slate-500 group-hover:text-orange-600">
                  View Products <ArrowRight size={16} className="ml-1" />
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link 
            to="/products" 
            className="inline-block bg-slate-900 text-white px-8 py-3 rounded font-bold hover:bg-orange-600 transition-colors"
          >
            View All Products
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ProductsOverview;
